'use client';

import * as React from 'react';
import { OnchainKitProvider } from '@coinbase/onchainkit';
import { base } from 'viem/chains';

interface OnchainKitWrapperProps {
  children: React.ReactNode;
}

export function OnchainKitWrapper({ children }: OnchainKitWrapperProps) {
  return (
    <OnchainKitProvider
      chain={base}
      config={{
        appearance: {
          name: 'Wafra Money',
          logo: '/assets/logo.svg',
          mode: 'auto',
          theme: 'default',
        },
        wallet: {
          display: 'modal',
          termsUrl: '/terms',
          privacyUrl: '/privacy',
        },
      }}
      apiKey={process.env.NEXT_PUBLIC_COINBASE_API_KEY}
      projectId={process.env.NEXT_PUBLIC_COINBASE_PROJECT_ID}
    >
      {children}
    </OnchainKitProvider>
  );
}
